export enum LoginState {
  Error = 'error',
  LoggedOut = 'logged-out',
  SigningIn = 'signing-in',
  SalesforceConnected = 'connected',
  LoggedIn = 'logged-in',
}
